export const MINUTE_IN_SECONDS = 60;
